import { render } from "./clear-optional-filters-button.vue?vue&type=template&id=2b1b8ebe&ts=true"
import script from "./clear-optional-filters-button.ts?vue&type=script&lang=ts&external"
export * from "./clear-optional-filters-button.ts?vue&type=script&lang=ts&external"

import "./clear-optional-filters-button.scss?vue&type=style&index=0&lang=scss&external"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__